import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ModalEntityCompiler from '../../components/Modals/ModalEntityCompiler';
import { DataManager } from '../../core/data-manager';
import { toast } from 'react-toastify';
import VoyageDocuments from '../components/VoyageDocuments';


export default function DGLTH_voyage({ item, entity = null, refreshData }) {

    useEffect(() => {
        //console.warn(item)
    }, []);

    const [statusModal, setStatusModal] = useState(false)

    function closeModal() {
        setStatusModal(false)
    }

    function openModal() {
        console.warn(item)
        setStatusModal(true)
    }

    function printDiv() {
        var DivID = 'printable'
        var disp_setting = "toolbar=yes,location=no,";
        disp_setting += "directories=yes,menubar=yes,";
        disp_setting += "scrollbars=yes,width=750, height=600, left=100, top=25";
        var content_value = document.getElementById(DivID).innerHTML;
        var docprint = window.open("", "", disp_setting);
        docprint.document.open();
        docprint.document.write('<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Strict//EN"');
        docprint.document.write('"http://www.w3.org/TR/xhtml1/DTD/xhtml1-strict.dtd">');
        docprint.document.write('<html xmlns="http://www.w3.org/1999/xhtml" xml:lang="en">');
        docprint.document.write('<head><title>Memorandum - ' + item.riferimento_merce + '</title>');
        docprint.document.write('<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@4.4.1/dist/css/bootstrap.min.css" integrity="sha384-Vkoo8x4CGsO3+Hhxv8T/Q5PaXtkKtu6ug5TOeNV6gBiFeWPGFN9MuhOf23Q9Ifjh" crossorigin="anonymous"></link>');
        docprint.document.write('<style type="text/css">body{margin:0px;}');
        docprint.document.write('a{color:#000;text-decoration:none;}</style>');
        docprint.document.write('</head><body onLoad="self.print()">');
        docprint.document.write(content_value);
        docprint.document.write('</body></html>');
        docprint.document.close();
        docprint.focus();
    }


    /* modal edit */
    const [statusModalEdit, setStatusModalEdit] = useState(false)
    const [dataModalEdit, setDataModalEdit] = useState({})

    async function edit() {
        var resp = await DataManager.getItem('voyage', item.id)
        if(resp.success === 1 && resp.body[0]) {
            setDataModalEdit(resp.body[0])
            setStatusModalEdit(true)
        }
    }

    function closeModalEdit() {
        setStatusModalEdit(false)
        setDataModalEdit({})
    }

    async function saveVoyage(data) {
        var id = item.id
        console.warn(id, data)
        if (id && data) {
            var response = await DataManager.updateItem('voyage', data, id)
            if (response.success === 1) {
                toast.success('Viaggio modificato con successo.', { theme: 'colored' });
                closeModalEdit()
                refreshData()
            }
            else {
                toast.error('Non è stato possibile modificare questo viaggio.', { theme: 'colored' });
            }
        }
        else {
            toast.error('Non è stato possibile modificare questo viaggio.', { theme: 'colored' });
        }
    }


    /** modal file */
    const [statusModalFile, setStatusModalFile] = useState(false)
    const [dataModalFile, setDataModalFile] = useState([])

    function openModalFile() {
        setStatusModalFile(true)
    }

    function closeModalFile() {
        setStatusModalFile(false)
        setDataModalFile([])
    }


    return (
        <>
            {item && item.ciclo && item.ciclo.value === 'EXPORT' ? (
                <>
                    <Button className='me-1' variant='secondary' size='sm' onClick={() => openModal()}>Memorandum</Button>
                    {statusModal !== false && (
                        <Modal show={statusModal} onHide={closeModal} backdrop="static" keyboard={false} size={'xl'} scrollable>
                            <Modal.Header closeButton>
                                <Modal.Title>Memorandum</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div id='printable'>
                                    <div className='text-center mt-5'>
                                        <h1>MEMORANDUM INGRESSO</h1>
                                        <h3>{item.terminalName}</h3>
                                        <h2>{item.riferimento_merce ? item.riferimento_merce : ''}</h2>
                                    </div>

                                    <div className='text-start mt-5'>
                                        <h3>NAVE: {item.ship}</h3>
                                        <h3>BOOKING: </h3>
                                        <h3>DESTINAZIONE: </h3>

                                        <h3 className='mt-5'>CASA DI SPEDIZIONI COME INDICATO SU LETTERA DI VETTURA<br />CONSEGNATA DAL TRASPORTATORE:</h3>
                                        <h1>{item.transitarioName} - {item.transitarioVatNumber}</h1>
                                    </div>

                                    <div className='text-start mt-5'>
                                        <h3>PESO KG.<br />MERCE</h3>
                                    </div>

                                    <div className='text-start mt-5 pt-5'>
                                        <h3 className='mb-4'>DATA CONSEGNA DOCUMENTI: {item.voyageDateTime}</h3>

                                        <p>
                                            Operatore: <b>{item.operatorUsername}</b>
                                            <br />
                                            Note: <b>{item.notes}</b>
                                        </p>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={closeModal}>
                                    Chiudi finestra
                                </Button>

                                <Button variant="warning" onClick={() => printDiv()}>
                                    <FontAwesomeIcon icon="print" className='me-1' /> Stampa
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    )}


                </>
            ) : (
                <></>
            )}


            <Button variant='outline-dark' size='sm' onClick={() => edit()} className='me-1'>Modifica</Button>
            <Button variant='outline-dark' size='sm' onClick={() => openModalFile()} className='me-1'><FontAwesomeIcon icon="folder" /></Button>
            {statusModalFile !== false && (
                <Modal show={statusModalFile} onHide={closeModalFile} backdrop="static" keyboard={false} size={'xl'} scrollable>
                    <Modal.Header closeButton>
                        <Modal.Title>File viaggio</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <VoyageDocuments voyageId={item.id}/>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={closeModalFile}>
                            Chiudi finestra
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
            <ModalEntityCompiler entity='voyage' confirmCallback={saveVoyage} initData={dataModalEdit} excludedFields={[]} status={statusModalEdit} close={closeModalEdit} />
        </>
    )
};